// extracted by mini-css-extract-plugin
export var productImage = "_xa-0";